import React from "react";
import { ResponsiveLine } from "@nivo/line";

export const LineChartGeneral = ({ width = 800, height = 700, datas = [], props = {} }) => {
    return (
        <ResponsiveLine
            data={datas}
            margin={{ bottom: 60, left: 80, right: 20, top: 20 }}
            xScale={{ type: "point" }}

            // yFormat=" >-.2f"
            enableArea
            enableSlices="x"
            pointSize={4}
            pointColor={{ theme: "background" }}
            pointBorderWidth={1}
            pointBorderColor={{ from: "serieColor" }}
            useMesh={true}
            colors={(parent) => {
                return parent.color;
            }}

            axisBottom={{
                tickSize: 8,
                tickPadding: 3,
                tickRotation: 69,
                legend: "",
                legendOffset: 35,
                legendPosition: "middle",
                truncateTickAt: 0,
            }}
            {...props}
        />
    );
};
